module.exports = __webpack_public_path__ + "static/media/people3-min.656e0eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/people3-min.png
// module id = 394
// module chunks = 0